/**
 * Receives UUID v7 and returns 8-character string that should be unique across different
 * UUIDs generated around the same time.
 */
export function getShortUuid(uuid: string): string {
    return uuid.slice(-8);
}

export function getShortUuidWithPrefix(uuid: string, prefix: string): string {
    return `${prefix}-${getShortUuid(uuid)}`.toUpperCase();
}

/**
 * Extracts the creation timestamp from a UUIDv7 identifier.
 * UUIDv7 encodes a Unix millisecond timestamp in its first 48 bits.
 */
export function getCreatedAtFromUuidV7(uuid: string): Date {
    const hex = uuid.replace(/-/g, "").slice(0, 12);
    return new Date(Number.parseInt(hex, 16));
}

const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUUID(uuid: string): boolean {
    return uuidRegex.test(uuid);
}
